import React, { useContext, useState } from 'react';

interface HomeParamsContextProps {
  params?: {
    LastLoggedDay?: string,
    IsConfi?: string,
    City?: string,
    Company?: string,
    KeyWord?: string,
    PageNumber?: number,
    RowsPerPage?: number,
    RegisterMinDate?: string,
    RegisterMaxDate?: string,
  }
  setParams?: React.Dispatch<any>,
}
const DEFULT_HOME_CONTEXT_PROPS:HomeParamsContextProps = {}
const HomeParamsContext = React.createContext<HomeParamsContextProps>(DEFULT_HOME_CONTEXT_PROPS);

const HomeParamsProvider = ({children}: any) => {
  const [HomeParamsContextParams, setHomeParamsContextParams] = useState(DEFULT_HOME_CONTEXT_PROPS.params);

  return (
    <HomeParamsContext.Provider
      value={{
        params: HomeParamsContextParams,
        setParams: setHomeParamsContextParams,
      }}
    >
      {children}
    </HomeParamsContext.Provider>
  )
}

const useHomeParams = () => {
  const context = useContext(HomeParamsContext);
  if (context === undefined) throw new Error('context must be used within a useTablePriceList');
  return context;
}

export {HomeParamsContext, HomeParamsProvider, useHomeParams}